import { Spinner, Text, VisuallyHidden } from '@n26/nxd'
import { useDashboardStructure } from '@/features/dashboard/api/queries'
import { SectionGroup } from '@/features/dashboard/tiles/SectionGroup'
import styles from './DashboardPage.module.css'

export const DashboardPage = () => {
  const { data: dashboard, isPending, isError } = useDashboardStructure()

  if (isPending) {
    return (
      <div className={styles.status} role='status'>
        <Spinner />
        <VisuallyHidden>Loading</VisuallyHidden>
      </div>
    )
  }

  if (isError) {
    return (
      <div className={styles.status} role='alert'>
        <Text color='rhubarb'>Couldn&apos;t load the dashboard.</Text>
      </div>
    )
  }

  return (
    <div className={styles.page}>
      {dashboard.sections
        .filter(section => section.kind === 'section')
        .map(section => (
          <SectionGroup key={section.id} section={section} />
        ))}
    </div>
  )
}
